import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '../store';


const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/VipView.vue'),

    },
    {
        path: "/wechat",
        name: 'wechat',
        component: () => import("../views/wechat.vue"),
        hidden: true,
      },

    {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue'),

    },
    {
        path: '/train',
        name: 'train',
        component: () => import('../views/trainView.vue')
    },
    {
        path: '/trainDetail',
        name: 'trainDetail',
        component: () => import('../views/trainDetail.vue')
    },
    {
        path: '/trainNext',
        name: 'trainNext',
        component: () => import('../views/trainNext.vue')
    },
    {
        path: '/trainCreate',
        name: 'trainCreate',
        component: () => import('../views/trainCreate.vue')
    },
    {
        path: '/vip',
        name: 'vip服务',
        component: () => import('../views/VipView.vue'),

    },
    {
        path: '/Studyabroad',
        name: '留学服务',
        component: () => import('../views/StudyabroadView.vue')
    },
    {
        path: '/Seedo',
        name: 'Seedo',
        component: () => import('../views/SeedoView.vue')
    },
    {
        path: '/International',
        name: 'International',
        component: () => import('../views/InternationalView.vue')
    },
    {
        path: '/InternationalNext',
        name: 'InternationalNext',
        component: () => import('../views/InternationalNext.vue')
    },
    {
        path: '/InternationalDetail',
        name: 'InternationalDetail',
        component: () => import('../views/InternationalDetail.vue')
    },
    {
        path: '/productionDetail',
        name: 'productionDetail',
        component: () => import('../views/productDetail.vue')
    },
    {
        path: '/InterCreate',
        name: 'InterCreate',
        component: () => import('../views/InternationalCreate.vue')
    },
    {
        path: '/Singleitem',
        name: 'Singleitem',
        component: () => import('../views/SingleitemView.vue')
    },
    {
        path: '/supervisor',
        name: 'Supervisor',
        component: () => import('../views/SupervisorView.vue')
    },
    {
        path: '/supervisor-detail/:id',
        name: 'SupervisorDetail',
        component: () => import('../views/SupervisorDetail.vue')
    },
    {
        path: '/Ranking',
        name: 'Ranking',
        component: () => import('../views/RankingView.vue')
    },
    {
        path: '/RankingNext',
        name: 'RankingNext',
        component: () => import('../views/RankingNext.vue')
    },
    {
        path: '/VipYRNext',
        name: 'VipYRNext',
        component: () => import('../views/VipYrNext.vue')
    },
    {
        path: '/VipLHNext',
        name: 'VipLHNext',
        component: () => import('../views/VipLhNext.vue')
    },
    {
        path: '/VipQZNext',
        name: 'VipQZNext',
        component: () => import('../views/VipQzNext.vue')
    },
    {
        path: '/VipGkNext',
        name: 'VipGkNext',
        component: () => import('../views/VipGkNext.vue')
    },
    {
        path: '/VipDlNext',
        name: 'VipDlNext',
        component: () => import('../views/VipDlNext.vue')
    },
    {
        path: '/SingleDetail',
        name: 'singleDetail',
        component: () => import('../views/SingleDetail.vue')
    },
    {
        path: '/caseDetail',
        name: 'caseDetail',
        component: () => import('../views/caseDetail.vue')
    },
    {
        path: '/VipCreata',
        name: 'vipCreata',
        component: () => import('../views/VipCreata.vue')
    },
    {
        path: '/VipDetail',
        name: 'vipDetail',
        component: () => import('../views/VipDetail.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/loginView.vue')
    },
    {
        path: '/VipNext',
        name: 'vipNext',
        component: () => import('../views/VipViewNext.vue')
    },
    {
        path: '/poster',
        name: 'poster',
        component: () => import('../views/poster.vue')
    },
    {
        path: '/poster2026',
        name: 'poster2026',
        component: () => import('../views/poster2026.vue')
    },
    {
        path: '/schoolPoster',
        name: 'schoolPoster',
        component: () => import('../views/schoolPoster.vue')
    },
    {
        path: '/schoolPoster2026',
        name: 'schoolPoster2026',
        component: () => import('../views/schoolPoster2026.vue')
    },
    {
        path: '/contract',
        name: 'contract',
        component: () => import('../views/contract.vue')
    },
    {
        path: '/mine',
        name: 'mine',
        component: () => import('../views/mine.vue')
    },
    
    {
        path: '/review',
        name: 'review',
        component: () => import('../views/review.vue')
    },
    {
        path: '/suppleAgreement',
        name: 'suppleAgreement',
        component: () => import('../views/suppleAgreement.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})



router.beforeEach((to, from, next) => {
    const token = sessionStorage.getItem('token');
    if (!token) {
        // 判断是否是/wechat
        if (to.path == '/wechat') {
            store.dispatch('updateLogin', true);
            next()
        } else {
            if (to.path !== '/login') {
                // 如果路由需要认证且没有 token，并且当前不是在登录页面，则重定向到登录页面
                store.dispatch('updateLogin', false);
                next('/login');
    
            } else {
                // 避免无限重定向，确保只在需要时重定向
                store.dispatch('updateLogin', true);
                next();
            }
        }
        

    } else {
        store.dispatch('updateLogin', false);
        next();
    }
});



export default router
